module.exports = __webpack_public_path__ + "db2568f3fa0be44910b6b3240de4de4f.png";